/**
 * Localization messages for RoleCardCondition component
 */
import sharedMessages from '../../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Role Condition': 'roleRecs.roleCardCondition.title',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RoleCardConditionMessage = keyof typeof invertedMessages;

export default invertedMessages;
